import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[80vh] flex items-center">
      <div className="container-x w-full">
        <div className="max-w-md mx-auto bg-white border border-border p-8 md:p-10">
          <p className="eyebrow">MIM Engineering</p>
          <h1 className="font-serif text-4xl md:text-5xl text-primary mt-3 leading-tight">Admin Sign In</h1>
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
            <div>
              <Label htmlFor="a-email">Email</Label>
              <Input id="a-email" data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 rounded-none" autoComplete="email" />
            </div>
            <div>
              <Label htmlFor="a-pass">Password</Label>
              <Input id="a-pass" data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 rounded-none" autoComplete="current-password" />
            </div>
            <Button type="submit" disabled={submitting} data-testid="admin-login-btn" className="w-full rounded-none uppercase tracking-[0.18em] text-xs py-3.5 h-auto">
              {submitting ? "Signing in…" : "Sign In"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
